















































































































































import countries from '@/data/countries.js';
import { api } from '@/services/api';
import { hideLoader, showLoader } from '@/utils/loading';
import { showAlert } from '@/utils/alert';

export default {
    name: 'NewPlaceFormView',

    data() {
        return {
            countries,

            placeForm: {
                name: '',

                location: {
                    lat: '',
                    lon: '',
                    address: {
                        // number: '',
                        street: '',
                        city: '',
                        county: '',
                        state: '',
                        countryCode: '',
                    },
                },
            },

            placeFormLabels: {
                // number: 'Number',
                street: 'Street',
                city: 'City',
                county: 'County',
                state: 'State',
                countryCode: 'Country',
            },
        };
    },

    created() {
        const addPlaceLocation: Location = this.$store.state.addPlaceLocation;
        if (addPlaceLocation) {
            this.placeForm.location.lat = addPlaceLocation.lat;
            this.placeForm.location.lon = addPlaceLocation.lon;

            this.placeForm.location.address.number = addPlaceLocation.address.number;
            this.placeForm.location.address.street = addPlaceLocation.address.street;
            this.placeForm.location.address.city = addPlaceLocation.address.city;
            this.placeForm.location.address.county = addPlaceLocation.address.county;
            this.placeForm.location.address.state = addPlaceLocation.address.state;
            this.placeForm.location.address.countryCode = addPlaceLocation.address.countryCode;
        }
    },

    methods: {
        submit() {
            showLoader();
            api.post(
                'places',
                this.placeForm,
            )
                .then((response) => {
                    console.log('Add response', response);
                    if (response.place) {
                        this.$router.push(`/place/${response.place.id}`);
                    }
                })
                .catch(({ message }) => {
                    showAlert(message);
                })
                .finally(() => {
                    hideLoader();
                });
        },
    },
};
